<script>
export default {
  name: 'UhNumberStepper',
  props: {
    existingValue: {
      type: Number,
      required: false,
      default: 0,
    },
    min: {
      type: Number,
      required: false,
      default: 0,
    },
    max: {
      type: Number,
      required: false,
      default: 0,
    },
    defaultValue: {
      type: String,
      required: false,
      default: '0',
    },
    displaySymbol: {
      type: String,
      required: false,
      default: '',
    },
    mobileWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    dusk: {
      type: String,
      required: false,
      default: '',
    },
    testId: {
      type: String,
      required: false,
      default: null,
    },
  },
  events: {
    update: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      currentValue: 0,
    };
  },
  watch: {
    existingValue(newValue) {
      this.currentValue = isNaN(newValue) ? 0 : newValue;
    },
  },
  created() {
    this.currentValue = isNaN(this.existingValue) ? 0 : this.existingValue;
  },
  methods: {
    emitChange() {
      this.$emit('update', this.currentValue);
    },
    increaseValue() {
      if (this.max !== 0 && this.max <= this.currentValue) {
        return;
      }

      this.currentValue++;
      this.emitChange();
    },
    decreaseValue() {
      if (this.currentValue <= this.min) {
        return;
      }
      this.currentValue--;
      this.emitChange();
    },
    displayValue() {
      return this.currentValue === 0
        ? this.defaultValue
        : this.currentValue + this.displaySymbol;
    },
  },
};
</script>

<template>
  <div>
    <div class="tw-text-center">
      <div
        class="tw-mb-2 tw-flex tw-flex-row tw-justify-center tw-text-base tw-font-normal tw-leading-4"
      >
        <slot name="label"></slot>
      </div>
    </div>
    <div class="tw-flex">
      <div
        class="tw-border-coolGray-300 tw-flex tw-h-12 tw-cursor-pointer tw-flex-row tw-items-center tw-px-2.5"
        :class="{ 'tw-w-36': !mobileWidth }"
      >
        <button
          class="tw-ml-1 tw-flex tw-h-full tw-w-14 tw-select-none tw-flex-row tw-content-center tw-items-center tw-justify-center tw-rounded-l-3xl tw-border tw-border-gray-300 hover:tw-bg-[#D7F6FF]"
          :dusk="`stepper-${dusk}-minus`"
          :data-testid="testId ? `${testId}-decrement` : null"
          type="button"
          @click.prevent="decreaseValue"
        >
          <img
            :src="cdnAsset('svg/listings/minus.svg')"
            alt="Minus icon"
            class="tw-h-4"
          />
        </button>

        <div
          class="tw-text-md tw-flex tw-h-full tw-w-14 tw-flex-col tw-content-center tw-items-center tw-justify-center tw-border-y tw-border-gray-300 tw-text-center tw-font-medium lg:tw-flex-row xl:tw-text-sm"
          :dusk="`stepper-${dusk}-value`"
          :data-testid="testId ? `${testId}-value` : null"
        >
          {{ displayValue(currentValue) }}
        </div>

        <button
          type="button"
          :dusk="`stepper-${dusk}-plus`"
          :data-testid="testId ? `${testId}-increment` : null"
          class="tw-flex tw-h-full tw-w-14 tw-select-none tw-flex-row tw-content-center tw-items-center tw-justify-center tw-rounded-r-3xl tw-border tw-border-gray-300 hover:tw-bg-[#D7F6FF]"
          @click.prevent="increaseValue"
        >
          <img
            :src="cdnAsset('svg/listings/plus.svg')"
            alt="Plus icon"
            class="tw-h-4"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
